import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
    trigger,
    transition,
    style,
    animate,
    state,
} from '@angular/animations';

@Component({
    selector: 'app-fc-benefits',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    animations: [
        trigger('slideAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate(
                    '300ms ease-out',
                    style({ transform: 'translateX(0)', opacity: 1 })
                ),
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1 }),
                animate(
                    '300ms ease-out',
                    style({ transform: 'translateX(-100%)', opacity: 0 })
                ),
            ]),
            state('current', style({ transform: 'translateX(0)', opacity: 1 })),
            state(
                'right',
                style({ transform: 'translateX(100%)', opacity: 0 })
            ),
            state(
                'left',
                style({ transform: 'translateX(-100%)', opacity: 0 })
            ),
            transition('right => current', [animate('300ms ease-out')]),
            transition('current => left', [animate('300ms ease-out')]),
            transition('left => current', [animate('300ms ease-out')]),
            transition('current => right', [animate('300ms ease-out')]),
        ]),
    ],
    templateUrl: './fc-benefits.component.html',
    styleUrl: './fc-benefits.component.scss',
})
export class FcBenefitsComponent implements OnInit {
    @Input() selectedLanguage: any = 'en';
    currentIndex = 0;
    activeIndex = 0;
    slideDirection: 'left' | 'right' = 'left';
    touchStartX = 0;
    touchEndX = 0;
    benefitsData: any = [
        {
            img: '/assets/images/fin-calculator/benefit1.png',
            title: 'Enter Your Financing Details',
            titleBm: 'Masukkan Butiran Pembiayaan Anda',
            desc: 'Input key financial information based on your business needs.',
            descBm: 'Input maklumat kewangan utama berdasarkan keperluan perniagaan anda.',
        },
        {
            img: '/assets/images/fin-calculator/benefit2.png',
            title: 'Find the Right Product',
            titleBm: 'Cari Produk yang Sesuai',
            desc: 'Get personalized financing options tailored to your calculations.',
            descBm: 'Dapatkan pilihan pembiayaan yang diperibadikan berdasarkan pengiraan anda. ',
        },
        {
            img: '/assets/images/fin-calculator/benefit3.png',
            title: 'Check Eligibility',
            titleBm: 'Semak Kelayakan',
            desc: "Instantly determine which financial solutions you're eligible for.",
            descBm: 'Kenal pasti penyelesaian kewangan yang anda layak secara serta-merta.',
        },
    ];

    isMobile = window.innerWidth < 768;

    ngOnInit() {
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 768;
        });
    }

    setActiveIndex(index: number): void {
        if (index !== this.activeIndex) {
            this.slideDirection = index > this.activeIndex ? 'left' : 'right';
            this.activeIndex = index;
        }
    }

    goToNext(): void {
        if (this.activeIndex < this.benefitsData.length - 1) {
            this.slideDirection = 'left';
            this.activeIndex++;
        }
    }

    goToPrevious(): void {
        if (this.activeIndex > 0) {
            this.slideDirection = 'right';
            this.activeIndex--;
        }
    }

    getSlideState(index: number): string {
        if (index === this.activeIndex) return 'current';
        return index < this.activeIndex ? 'left' : 'right';
    }

    @HostListener('touchstart', ['$event'])
    onTouchStart(event: TouchEvent): void {
        this.touchStartX = event.touches[0].clientX;
    }

    @HostListener('touchend', ['$event'])
    onTouchEnd(event: TouchEvent): void {
        this.touchEndX = event.changedTouches[0].clientX;
        this.handleSwipe();
    }

    handleSwipe(): void {
        const swipeThreshold = 50;
        if (this.touchStartX - this.touchEndX > swipeThreshold) {
            this.goToNext();
        } else if (this.touchEndX - this.touchStartX > swipeThreshold) {
            this.goToPrevious();
        }
    }
}
